import * as am5 from "@amcharts/amcharts5";
import * as _ from "lodash"

export const Am5SeriesColor = class {
    static DEFAULT_COLOR = am5.color("#3d81f7")

    static SERIES_COLORS = [
        // Default Sonicu Blue
        am5.color("#3d81f7"),

        // Chartreuse / Lime-Green
        am5.color("#7fff00"),

        // Teal-Green
        am5.color("#30d5c8"),

        // Plum-Purple
        am5.color("#3d1a39"),

        // Carrot-Orange
        am5.color("#fd6a02"),

        // Cinnamon
        am5.color("#7b3f00"),

        // Crimson Red
        am5.color("#dc143c"),

        // Forest Green
        am5.color("#228b22"),

        // Gold
        am5.color("#ffd700"),

        // Deep Pink
        am5.color("#ff1493"),

        // Royal Blue
        am5.color("#4169e1"),

        // Orange Red
        am5.color("#ff4500"),

        // Medium Purple
        am5.color("#9370db"),

        // Dark Turquoise
        am5.color("#00ced1"),

        // Chocolate
        am5.color("#d2691e"),

        // Lime
        am5.color("#32cd32"),

        // Hot Pink
        am5.color("#ff69b4"),

        // Steel Blue
        am5.color("#4682b4"),

        // Dark Orange
        am5.color("#ff8c00"),

        // Medium Sea Green
        am5.color("#3cb371"),
    ]

    static usedColors = []
    static availableColors = []

    static currentColorIndex = 0

    static hasNextColor() {
        return Am5SeriesColor.availableColors.length > 0
    }

    static peekNextColor() {
        if (!Am5SeriesColor.hasNextColor()) {
            return false
        }

        let lastIndex = Am5SeriesColor.availableColors.length - 1
        return Am5SeriesColor.SERIES_COLORS[Am5SeriesColor.availableColors[lastIndex]]
    }

    static nextColor() {
        if (!Am5SeriesColor.hasNextColor()) {
            return Am5SeriesColor.DEFAULT_COLOR
        }

        let colorIndex = Am5SeriesColor.availableColors.pop()
        Am5SeriesColor.usedColors.push(colorIndex)

        return Am5SeriesColor.SERIES_COLORS[colorIndex]
    }

    static resetColors() {
        let colorsIndexes = _.range(Am5SeriesColor.SERIES_COLORS.length)
        Am5SeriesColor.availableColors = colorsIndexes.reverse()
    }

    static releaseColor(color) {
        let colorIndex = Am5SeriesColor.getIndexFromColor(color)
        console.log(`Releasing Color: ${colorIndex}`)

        Am5SeriesColor.availableColors.push(colorIndex)
        let usedIndex = Am5SeriesColor.usedColors.indexOf(colorIndex)
        if (usedIndex !== -1) {
            Am5SeriesColor.usedColors.splice(usedIndex, 1)
        }
    }

    static getColorFromIndex(index = null) {
        let currentIndex = _.isNil(index) ? Am5SeriesColor.currentColorIndex : index

        return currentIndex < Am5SeriesColor.SERIES_COLORS.length
                ? Am5SeriesColor.SERIES_COLORS[Am5SeriesColor.currentColorIndex]
                : null
    }

    static getIndexFromColor(color) {
        let index = Am5SeriesColor.SERIES_COLORS.indexOf(color)

        return index === -1
            ? null
            : index
    }
}
